import { render, staticRenderFns } from "./AdjustRecords.vue?vue&type=template&id=0b525911&scoped=true"
import script from "./AdjustRecords.vue?vue&type=script&lang=js"
export * from "./AdjustRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b525911",
  null
  
)

export default component.exports